var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.1899 68.56C70.4899 78.26 55.2199 79.28 50.7899 79.37C50.0999 79.38 49.5399 78.82 49.5499 78.13C49.6399 73.7 50.6499 58.43 60.3599 48.73C70.0699 39.03 85.3299 38.01 89.7599 37.92C90.4499 37.91 91.0099 38.47 90.9999 39.16C90.9099 43.59 89.8999 58.86 80.1899 68.56Z",
    fill: "#F9907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.81 68.56C29.51 78.26 44.78 79.28 49.21 79.37C49.9 79.38 50.46 78.82 50.45 78.13C50.36 73.7 49.35 58.43 39.64 48.73C29.93 39.03 14.67 38.01 10.24 37.92C9.55001 37.91 8.99001 38.47 9.00001 39.16C9.09001 43.59 10.1 58.86 19.81 68.56Z",
    fill: "#F9907B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.26 47.95C34.26 62.91 45.25 75.47 48.6 78.95C49.12 79.49 49.99 79.49 50.51 78.95C53.86 75.47 64.85 62.91 64.85 47.95C64.85 32.99 53.86 20.43 50.51 16.95C49.99 16.41 49.12 16.41 48.6 16.95C45.25 20.43 34.26 32.99 34.26 47.95Z",
    fill: "#FAC1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathe);
export default __webpack_public_path__ + "static/media/Breathe.d2486f039ff66aacc22fd171d4f49c99.svg";
export { ForwardRef as ReactComponent };